var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M16,0H2A2,2,0,0,0,0,2V16a2,2,0,0,0,2,2H16a2,2,0,0,0,2-2V2A2,2,0,0,0,16,0Z",
    fill: "#db2828"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1270",
    "data-name": "Path 1270",
    d: "M1.4-3.578h.824V-7.124c0-.709-.066-1.428-.1-2.109h.037L2.9-7.842,5.4-3.578h.889v-6.76H5.462V-6.82c0,.7.066,1.455.112,2.137H5.528L4.8-6.074,2.3-10.338H1.4Zm9.454.12a2.973,2.973,0,0,0,2.125-.783V-7.078H10.732v.709h1.451V-4.6a1.9,1.9,0,0,1-1.236.4c-1.479,0-2.293-1.068-2.293-2.772,0-1.685.9-2.735,2.275-2.735a1.938,1.938,0,0,1,1.488.645l.468-.553a2.63,2.63,0,0,0-1.975-.838c-1.816,0-3.145,1.326-3.145,3.509S9.057-3.459,10.854-3.459Z",
    transform: "translate(1.811 16.169)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNgIcon);
export default __webpack_public_path__ + "static/media/ng-icon.940b15fa5e35b65d60d0cbf29ef764e7.svg";
export { ForwardRef as ReactComponent };